import localeNl from '@angular/common/locales/nl';
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';

import { MijnProductOpenenModule } from './mijn-product-openen.module';

registerLocaleData(localeNl, 'nl');

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

platformBrowser()
    .bootstrapModule(MijnProductOpenenModule)
    // eslint-disable-next-line no-console
    .catch((err) => console.log(err)); // NOSONAR
